import { ClipboardCheckIcon, ClipboardIcon } from '@heroicons/react/outline';
import React from 'react';
import { useState } from 'react';

export default function CopyToClipboardButton({ url }) {
  const [isClicked, setIsClicked] = useState(false);

  function copyToClipboard() {
    navigator.clipboard.writeText(url);
    setIsClicked(true);

    setTimeout(() => {
      setIsClicked(false);
    }, 1000);
  }

  return (
    <>
      <div className={isClicked ? '-rotate-12 text-teal-500' : 'text-teal-600'}>
        {isClicked ? (
          <ClipboardCheckIcon className="h-6 w-6"></ClipboardCheckIcon>
        ) : (
          <ClipboardIcon onClick={copyToClipboard} className="h-6 w-6"></ClipboardIcon>
        )}
      </div>
    </>
  );
}
